<!-- 场所及设备情况表 -->

<template>
  <div class="tabCage table7E">
    <div class="tabTtl">
      <span>表 1-7：受处罚情况表</span>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">是否有处罚情况：</td>
            <td class="edInp">
              <el-form-item prop="isPunishment" :inline-message="true">
                <el-select v-model="params.isPunishment" @change="isHandle" size="small" placeholder="请选择处罚情况">
                  <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">具体情况：</td>
            <td class="edInpTextArea">
              <el-form-item v-if="basFirm" prop="punishment" :inline-message="true">
                <el-input :rows="3" type="textarea" v-model="params.punishment" size="small"></el-input>
              </el-form-item>

              <el-input v-else :rows="5" type="textarea" v-model="params.punishment" size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="tipsLine">
              <div class="tips">
                注：
                填写2023年和2024年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。
              </div>
            </td>
          </tr>
        </table>
        <div class="headBar">
          <span>申报人信息</span>
        </div>
        <div class="editArea newEditArea">
          <div class="editBox">
            <p class="edName">申报人：</p>
            <div class="edInp">
              <el-input size="small" v-model="declare.personnel" placeholder="请输入申报人"></el-input>
            </div>
          </div>
          <div class="editBox">
            <p class="edName">联系方式：</p>
            <div class="edInp">
              <el-input size="small" v-model="declare.contact" placeholder="请输入申报人联系方式"></el-input>
            </div>
          </div>
          <div class="editBox">
            <p class="edName">申报时间：</p>
            <div class="edInp">
              <el-input size="small" v-model="params.updatedAt" :disabled="true"></el-input>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small">保存</el-button>
    </div>
  </div>
</template>

<script>
import { CONST } from "@/constraints";
import { tabUpdate7, tabRead7 } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      params: {
        isPunishment: "",
        punishment: "",

        id: "",
        publishId: "",
        publishMaterialId: "",
        // 可能是缩紧不对写错位置了
        // basFirm:true,
        // isMap:{},
        // updatedAt:'',
      },
      isMap: {},
      basFirm: true,
      rules: {
        isPunishment: [{ required: true, message: "请选择", trigger: "change" }],
        punishment: [
          { required: true, message: "不能为空！", trigger: "blur" },
          { max: 600, message: "填写内容过长！", trigger: "change" },
        ],
      },
      dicDats: {},
      submiting: false,
      declare: {
        personnel: "",
        contact: "",
      },
      pubStatus: 0,
    };
  },
  methods: {
    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        this.params.publishId = this.$route.query.pressId;
        this.params.publishMaterialId = this.$route.query.mtId;
        if (!this.declare.personnel) {
          this.$message.error("申报人姓名必填");
          return;
        }
        // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
        // 	this.$message.error('申报人手机号格式错误');
        // 	return
        // }
        if (!this.declare.contact) {
          this.$message.error("申报人联系方式必填");
          return;
        }
        if (valid) {
          tabUpdate7({
            publishMaterialId: this.params.publishMaterialId,
            data: this.params,
            organizationPersonnel: this.declare,
          })
            .then((response) => {
              let tipCode = response.payload.ppunishment.code;
              let tipMessage = response.payload.ppunishment.message;

              this.submiting = false;
              if (tipCode == -1) {
                this.$message.error(`保存错误: ${tipMessage}`);
              } else {
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });

                // this.editAfter(response);
                this.goBack();
              }

              // console.log('response: ', response)
              // this.submiting = false;
              // if (response.code && response.code != 0) {
              // 	console.error('提交错误: ', response.message, response)
              // 	this.$message.error(`提交错误: ${response.message || response.error}`);
              // 	return
              // }
              // this.$message({
              // 		message: '保存成功！',
              // 		type: 'success'
              // });
              // this.goBack();
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function () {
      tabRead7({ publishMaterialId: this.$route.query.mtId }).then((response) => {
        this.params = response.ppunishment;
        if (response.pOrganizationPersonnel !== null) {
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          // TODO: 这个完全没必要吧？ 概念混了？
          // this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },

    dictInit: function () {
      let nameArr = ["C018"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then((result) => {
        this.isMap = this.$store.getters.dictionary["C018"];
        console.debug("isMap: ", this.isMap);
        this.dicDats = result;
      });
    },

    isHandle: function () {
      if (this.isMap[this.params.isPunishment] == "是") {
        this.basFirm = true;
      } else {
        this.basFirm = false;
      }
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },

  created: function () {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table7E .edInp .el-textarea {
  width: 450px;
}

.table7E .tipsLine .tips {
  font-size: 12px;
  color: #999999;
  padding: 0px 12px;
}

.table7E {
  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 12px;
  }

  .newEditArea {
    width: 80%;
    margin: 0 auto;
    padding: 30px;

    .editBox {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        float: left;
        width: 100px;
        text-align: right;
      }

      .edInp {
        width: 300px;
        float: left;
        margin: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// table7.vue?6cac25d0